const postResetPasswordPayload = (data) => {
  return {
    password: data?.password,
  };
};

export default postResetPasswordPayload;
